
import { defineComponent, PropType } from '@nuxtjs/composition-api'
import { FutureProfItemModel } from '~/model'

export default defineComponent({
  name: 'FutureProfessionsCard',
  props: {
    card: {
      type: Object as PropType<FutureProfItemModel>,
      required: true
    }
  }
})
